import Bus from "@/lib/Bus"
import { MasterData } from "@/store/MasterData";
 const bus: Bus = new Bus().getBus();
 import { IUser } from "@/../../server/src/user/IUser";

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    Store: Store;
  }
}


export default class Store {
  _masterData: any;
  masterData:MasterData|undefined;
  user:IUser|undefined;
  interval_id:any=null;

  async getStore():Promise<Store> {
    if (!window.Store) {
      bus.register("on_login", this.on_login);
      this._masterData = document.createElement("div");
      window.Store = this;
      console.log('call masterData')
      await this.read_all();
      const millisecondsPerMinute=60*1000;
      this.interval_id=setInterval( async () => {  await this.read_all(); }, millisecondsPerMinute*4.8);

      return window.Store;
    } else {
      return window.Store;
    }
  }

  async read_all() {
    this.masterData = await bus.call('/api/masterdata/get_masterdata',{})
    if (this.masterData) {
      console.log('got masterData OK')
      bus.fire("masterdata_refresh",{})
    }
    else console.error('/api/masterdata/get_masterdata returned null')
  }

  async on_login(e: any) {
  }

  async on_logout() {
    this.masterData = undefined
  }

}
